module.exports = __webpack_public_path__ + "static/media/bg3.f807b37b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg3.jpg
// module id = 3533
// module chunks = 0